import type { RouteLocationRaw } from 'vue-router';
import employeeService from '@/services/employee.service';
import i18n from '@/config/i18n';
import { CalendarResourceType } from '@/store/calendar-store';
import { useUsersStore } from '@/store/users-store';
import { useUiStore } from '@/store/ui-store';

const CALENDAR: RouteLocationRaw = {
  name: 'Calendar',
  query: { viewType: CalendarResourceType.EMPLOYEE },
};

export default async function (): Promise<true | RouteLocationRaw> {
  const usersStore = useUsersStore();
  if (usersStore.isAdmin) {
    return true;
  }

  const employeeId = usersStore.loggedInEmployeeId;
  const employee = employeeId
    ? await employeeService.getById(employeeId)
    : null;

  if (employee?.can_set_timetable) {
    return true;
  }

  useUiStore().alert(i18n.global.t('guard.insufficientPermissions'));
  return CALENDAR;
}
